import { render, staticRenderFns } from "./DialogLogout.vue?vue&type=template&id=2bae801d"
import script from "./DialogLogout.vue?vue&type=script&lang=ts"
export * from "./DialogLogout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports